import { useContext } from 'react';
import { PreferenceService } from '@bingads-webui/preference-service';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { SWITCH_BACK_NAV_REFRESH_KEY } from './constants';

export const isNavigationRefreshOn = (permissions) => {
  const preferenceService = PreferenceService;
  const switchBackNavRefreshPreference = preferenceService.findByNameAtUserLevel(SWITCH_BACK_NAV_REFRESH_KEY);
  return permissions.dynamic && permissions.dynamic.NavigationRefresh && (!switchBackNavRefreshPreference || !switchBackNavRefreshPreference.Data);
};

export const useNavigationRefreshPreference = () => {
  const permissions = useContext(PermissionsContext);

  return {
    isNavigationRefreshOn: isNavigationRefreshOn(permissions),
  };
};
